"use strict";

exports.__esModule = true;
exports.HistogramDurationRangeSelector = HistogramDurationRangeSelector;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _createDurationRangeList = require("./createDurationRangeList");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var clone = require("ramda").clone;
function HistogramDurationRangeSelector(props) {
  var value = props.value,
    setProp = props.setProp;
  var sources = ["second", "minute", "hour"];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  /** state to store start value and unit of duration range */
  var _useState = (0, _react.useState)(value),
    rangeStartList = _useState[0],
    setRangeStartList = _useState[1];
  (0, _react.useEffect)(function () {
    setProp(rangeStartList);
  }, [rangeStartList]);
  var durationRangeValidator = function durationRangeValidator(rangeList, index) {
    var prev;
    var current = (0, _createDurationRangeList.convertToMillis)(rangeList[index]);
    if (index !== 0) {
      prev = (0, _createDurationRangeList.convertToMillis)(rangeList[index - 1]);
      return current > prev;
    }
    return true;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("Histogram.HistogramDurationRange.label", "Cycle Range"),
    helperText: translate("Histogram.HistogramDurationRange.helperText", "Specify start of range.")
  }, rangeStartList.map(function (range, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: range.from + "-" + index,
      "data-testid": "HistogramDurationRange",
      style: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "2px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      style: {
        maxWidth: "100px"
      },
      "data-testid": "HistogramDurationRange.start-" + index,
      type: "number",
      id: "Scale",
      name: "Range",
      value: range.from,
      onChange: function onChange(event) {
        var newList = clone(rangeStartList);
        newList[index].from = Number(event.target.value);
        setRangeStartList(newList);
      }
    }), /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
      style: {
        minWidth: "90px"
      },
      getKey: function getKey(source) {
        return source;
      },
      multiple: false,
      items: sources,
      selected: [range.unit],
      renderItemText: function renderItemText(source) {
        return source;
      },
      onSelect: function onSelect(_ref) {
        var source = _ref[0];
        var newList = clone(rangeStartList);
        newList[index].unit = source;
        setRangeStartList(newList);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      style: {
        margin: "auto 5px",
        cursor: "pointer"
      },
      icon: _icons.IconNames.DELETE,
      color: "#ccc",
      onClick: function onClick() {
        setRangeStartList(rangeStartList.filter(function (_, i) {
          return i !== index;
        }));
      }
    }), !durationRangeValidator(rangeStartList, index) ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      style: {
        margin: "auto 5px",
        cursor: "help"
      },
      icon: _icons.IconNames.WARNING_SIGN,
      intent: _core.Intent.WARNING,
      htmlTitle: "The values should be monotonously increasing"
    }) : null);
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    icon: _icons.IconNames.ADD,
    text: translate("Histogram.AddButton.text", "Add Range"),
    onClick: function onClick() {
      var isEmpty = rangeStartList.length === 0;
      if (isEmpty) {
        setRangeStartList([{
          from: 0,
          unit: "minute"
        }]);
      } else {
        var last = rangeStartList[rangeStartList.length - 1];
        var newVal = {
          from: last.from + 1,
          unit: last.unit
        };
        setRangeStartList([].concat(rangeStartList, [newVal]));
      }
    }
  })));
}